import { filterPanels } from 'common/api/v1/panelsCompanies';

import {
    FETCH_ITEMS,
    FETCH_ITEMS_FAILURE,
    FETCH_ITEMS_SUCCESS,
} from '../actionTypes';
import { panelsActions } from '../reducer';

export default ({
        orderBy,
        page = 0,
        pageSize,
        searchText,
        sortBy,
        status,
    } = {}) =>
    (dispatch) => {
        dispatch(panelsActions[FETCH_ITEMS]());

        filterPanels({
            orderBy,
            page: page + 1,
            perPage: pageSize,
            searchText,
            sortBy,
            status,
        })
            .then((response) =>
                dispatch(panelsActions[FETCH_ITEMS_SUCCESS](response.data)),
            )
            .catch((error) =>
                dispatch(
                    panelsActions[FETCH_ITEMS_FAILURE](
                        error?.response?.data?.errors,
                    ),
                ),
            );
    };
